import { Controller } from "@hotwired/stimulus";
import autosize from "autosize";

// autosize() is a no-op on anything that isn't a TEXTAREA, so #build_from (a %span) only ever
// picks up the auto-resize class. Both calls run unconditionally rather than branching on tag.
//
// No disconnect()/autosize.destroy(): #current-card's swap replaces the DOM node outright, so
// autosize's internal WeakMap never sees the same node twice.
export default class extends Controller {
  static get classes() {
    return ["autoResize"];
  }

  connect() {
    autosize(this.element);
    this.element.classList.add(this.hasAutoResizeClass ? this.autoResizeClass : "auto-resize");
  }
}
